/**
 * Escapes "%" as "\%" and wraps in "%" for ILIKE comparisons
 *
 * @param {string} s
 */
export const wrapPercents = s => {
  // dont wrap twice
  if (/^%(.*)%$/.test(s)) {
    return s;
  }
  if (!s) {
    return '';
  }
  const escaped = s.replace(/%/g, '\\%');
  const wrapped = `%${escaped}%`;
  return wrapped;
};

/**
 * Unwraps "%", unescapes "\%", and optionally removes "||"
 *
 * @param {string} s
 * @param {object} options
 * @param {boolean} options.removePipes
 */
export const unwrapPercents = (s, { removePipes } = {}) => {
  if (removePipes) {
    s = s.replace(/\|\|/g, '');
  }

  // already unwrapped
  if (!/^%(.*)%$/.test(s)) {
    return s;
  }

  return s
    ? s
        // wrap in percent
        .replace(/^%(.*)%$/, '$1')
        // unescape \%
        .replace(/\\%/g, '%')
    : '';
};
